<template>
  <slot></slot>
</template>

<script setup>
import { provide, useAttrs } from 'vue'
import { ATTRIBUTES } from './keys'

defineOptions({
  inheritAttrs: false
})

const attrs = useAttrs()
provide(ATTRIBUTES, attrs)
</script>
